<template>
  <my-view :PtGetOrderInfoToPay="PtGetOrderInfoToPay" :PtGetOrderPayFeeInfo="PtGetOrderPayFeeInfo" :PtPageOrderPay="PtPageOrderPay"></my-view>
</template>

<script>
import {
  PtGetOrderInfoToPay,
  PtGetOrderPayFeeInfo,
  PtPageOrderPay,
} from "@/pages/page1/api/modules/order";

import MyView from "@/pages/publicView/paymentProcess/payType/platePay_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      PtGetOrderInfoToPay,
      PtGetOrderPayFeeInfo,
      PtPageOrderPay,
    };
  },
};
</script>